 (() => {
  'use strict';

  if (window.OG_ADDON_POPUP_LOADED) return;
  window.OG_ADDON_POPUP_LOADED = true;

  const FEE_VARIANT_BY_AMOUNT = {
    "0": 52031167267096,
    "49":  52031166775576,
    "99":  52031166808344,
    "149":  52031166841112,
    "199":  52031166873880,
    "249":  52031166906648,
    "250":  52031166939416,
    "299":  52031166972184,
    "300":  52031167004952,
    "349":  52031167037720,
    "350":  52031167070488,
    "399":  52031167103256,
    "400":  52031167136024,
    "450":  52031167168792,
    "500":  52031167201560,
    "550": 52031167234328
  };

  const DEFAULT_CONFIG = {
    collectionHandle: 'addons',
    collectionUrl: '',
    collectionProductsJsonUrl: '',
    productTags: [],
    currentProductIsExpress: false,
    currentProductIsCourier: false,
    currentProductHasAddons: false,
    addonSource: 'none',

    buyNowSelector: 'button[id^="ProductSubmitButton-"], button[name="add"], .product-form__submit, [type="submit"][name="add"]',
    productFormSelector: 'form[action*="/cart/add"]',

    requiredProductTag: '',
    cartDrawerSelector: 'cart-drawer#CartDrawer, cart-drawer, #CartDrawer.cart-drawer, #CartDrawer',
    cartDrawerTriggerSelector: '',

    openCartDrawerAfterAdd: false,
    openCartDrawerOnPopupClose: false,
    redirectToCartAfterAdd: false,
    redirectToCheckoutAfterAdd: true,

    requireDeliverySelection: true,
    requireOptisRequiredOptions: true,

    requireSenderName: false,
    requireSenderPhone: false,
    requireMessage: false,

    maxAddonsProductsToShow: 24,
    maxAddonsSelectable: 8,

    enableSkipAddons: true,
    strictBlockAddonVariants: true,

    senderStorageHours: 24,
    currencySymbol: '₹',

    enableDeliveryFeeItem: true,
    deliveryFeeProductId: 10259790332184,
    deliveryFeeVariantByAmount: FEE_VARIANT_BY_AMOUNT,

    deliveryFeeFallbackByType: {
      express: 49,
      'express delivery': 49,
      fixed: 249,
      'fixed time': 249,
      'fixed time delivery': 249,
      midnight: 349,
      'midnight delivery': 349,
      standard: 0,
      'standard delivery': 0,
      morning: 299,
      'morning delivery': 299,
      'next day': 0,
      'next day delivery': 0,
      remote: 0,
      'remote delivery': 0
    }
  };

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const normalizeText = value => String(value || '').replace(/\s+/g, ' ').trim();
  const normalizeLower = value => normalizeText(value).toLowerCase();

  const normalizePrice = value => {
    if (value === null || value === undefined) return 0;

    const original = String(value);
    const raw = original
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '')
      .trim();

    if (!raw) return 0;

    const parsed = Number(raw);

    if (!Number.isFinite(parsed)) return 0;

    if (!original.includes('.') && Number.isInteger(parsed) && parsed >= 10000) {
      return parsed / 100;
    }

    return parsed;
  };

  const readConfig = () => {
    const node = $('#OgAddonPopupConfig');

    if (!node) return DEFAULT_CONFIG;

    try {
      const userConfig = JSON.parse(node.textContent || '{}');

      return {
        ...DEFAULT_CONFIG,
        ...userConfig,
        deliveryFeeVariantByAmount: {
          ...FEE_VARIANT_BY_AMOUNT,
          ...(userConfig.deliveryFeeVariantByAmount || {})
        },
        deliveryFeeFallbackByType: {
          ...DEFAULT_CONFIG.deliveryFeeFallbackByType,
          ...(userConfig.deliveryFeeFallbackByType || {})
        }
      };
    } catch (error) {
      console.warn('[OG Addon] Invalid config JSON:', error);
      return DEFAULT_CONFIG;
    }
  };

  const config = readConfig();

  Object.keys(FEE_VARIANT_BY_AMOUNT).forEach(key => {
    if (!config.deliveryFeeVariantByAmount[key]) {
      config.deliveryFeeVariantByAmount[key] = FEE_VARIANT_BY_AMOUNT[key];
    }
  });

  const popup = $('#OgAddonPopup');
  if (!popup) return;

  if (!document.getElementById('OgAddonRequiredOptionStyle')) {
    const style = document.createElement('style');
    style.id = 'OgAddonRequiredOptionStyle';
    style.textContent = `
      .og-option-required-error {
        outline: 2px solid #d92d20 !important;
        outline-offset: 4px !important;
        border-radius: 10px !important;
      }
      .og-option-required-message {
        margin-top: 6px;
        color: #d92d20;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.35;
      }
    `;
    document.head.appendChild(style);
  }

  const els = {
    grid: $('[data-og-addon-grid]', popup),
    loading: $('[data-og-addon-loading]', popup),
    empty: $('[data-og-addon-empty]', popup),
    status: $('[data-og-addon-status]', popup),
    count: $('[data-og-addon-count]', popup),
    extra: $('[data-og-addon-extra]', popup),
    continueBtn: $('[data-og-addon-continue]', popup),
    skip: $('[data-og-addon-skip]', popup),
    back: $('[data-og-addon-back]', popup),
    senderName: $('[data-og-sender-name]', popup),
    senderPhone: $('[data-og-sender-phone]', popup),
    senderMessage: $('[data-og-sender-message]', popup),
    subtitle: $('[data-og-addon-subtitle]', popup)
  };

  const state = {
    activeForm: null,
    currentSlide: 'addons',
    currentProductVariantId: 0,
    currentProductHandle: '',
    products: [],
    addonVariantIds: new Set(),
    selected: new Map(),
    loaded: false,
    loading: false,
    adding: false,
    cleaning: false
  };

  const shopifyRoutes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : {};
  const root = shopifyRoutes.root || '/';
  const SENDER_STORAGE_KEY = 'og_addon_sender_details_v8';

  const apiUrl = path => {
    const cleanRoot = root.endsWith('/') ? root.slice(0, -1) : root;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanRoot}${cleanPath}`;
  };

  const show = node => {
    if (node) node.hidden = false;
  };

  const hide = node => {
    if (node) node.hidden = true;
  };

  const unlockPage = () => {
    document.body.classList.remove('og-addon-lock');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'menu-opening');
    document.documentElement.classList.remove('overflow-hidden', 'menu-opening');

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.documentElement.style.removeProperty('overflow');
  };

  const isAddonEnabledProductPage = () => {
    if (config.currentProductHasAddons === true) return true;
    if (config.currentProductIsExpress === true) return true;
    if (config.currentProductIsCourier === true) return true;

    const tags = Array.isArray(config.productTags)
      ? config.productTags.map(tag => normalizeLower(tag))
      : [];

    if (tags.includes('express gifts') || tags.includes('courier gifts')) return true;

const bodyText = normalizeLower(document.body.textContent || '');

if (bodyText.includes('tag: express gifts') || bodyText.includes('tags: express gifts')) return true;
if (bodyText.includes('tag: courier gifts') || bodyText.includes('tags: courier gifts')) return true;

    return false;
  };

  const setStatus = (message = '', type = '') => {
    if (!els.status) return;

    els.status.textContent = message;
    els.status.className = 'og-addon__notice';

    if (type) {
      els.status.classList.add(`is-${type}`);
    }

    message ? show(els.status) : hide(els.status);
  };

  const formatMoney = value => {
    const amount = normalizePrice(value);
    return `${config.currencySymbol}${Math.round(amount).toLocaleString('en-IN')}`;
  };

  const escapeHtml = value => {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const getCurrentProductHandleFromUrl = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const getImage = product => {
    if (product.image && product.image.src) return product.image.src;

    if (Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === 'string') return product.images[0];
      return product.images[0].src || '';
    }

    return '';
  };

  const getAvailableVariant = product => {
    if (!Array.isArray(product.variants)) return null;
    return product.variants.find(variant => variant.available) || product.variants[0] || null;
  };

  const getProductPrice = product => {
    const variant = getAvailableVariant(product);
    return variant ? variant.price : product.price || 0;
  };

  const clearSenderErrors = () => {
    $$('[data-og-error-for]', popup).forEach(item => {
      item.textContent = '';
    });
  };

  const setSenderError = (key, message) => {
    const node = $(`[data-og-error-for="${key}"]`, popup);
    if (node) node.textContent = message;
  };

  const saveSenderDetails = () => {
    try {
      const payload = {
        expiresAt: Date.now() + (Number(config.senderStorageHours || 24) * 60 * 60 * 1000),
        values: {
          senderName: String(els.senderName?.value || '').trim(),
          senderPhone: String(els.senderPhone?.value || '').replace(/\D/g, '').slice(0, 10),
          message: String(els.senderMessage?.value || '').trim()
        }
      };

      localStorage.setItem(SENDER_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      console.warn('[OG Addon] Sender save skipped:', error);
    }
  };

  const loadSenderDetails = () => {
    try {
      const raw = localStorage.getItem(SENDER_STORAGE_KEY);
      if (!raw) return;

      const payload = JSON.parse(raw);

      if (!payload || !payload.expiresAt || Date.now() > Number(payload.expiresAt)) {
        localStorage.removeItem(SENDER_STORAGE_KEY);
        return;
      }

      const values = payload.values || {};

      if (els.senderName) els.senderName.value = values.senderName || '';
      if (els.senderPhone) els.senderPhone.value = values.senderPhone || '';
      if (els.senderMessage) els.senderMessage.value = values.message || '';
    } catch (error) {
      console.warn('[OG Addon] Sender load skipped:', error);
    }
  };

  const resetSender = () => {
    loadSenderDetails();
    clearSenderErrors();
  };

  const setContinueText = text => {
    if (els.continueBtn) els.continueBtn.textContent = text;
  };

  const setSlide = slide => {
    state.currentSlide = slide;

    $$('[data-og-slide]', popup).forEach(item => {
      item.classList.toggle('is-active', item.dataset.ogSlide === slide);
    });

    $$('[data-og-step-dot]', popup).forEach(dot => {
      dot.classList.toggle('is-active', dot.dataset.ogStepDot === (slide === 'addons' ? '1' : '2'));
    });

    setContinueText('Continue with Gift →');

    if (els.skip) {
      els.skip.textContent = slide === 'addons' ? 'Skip Add-ons' : 'Skip Sender Details';
    }

    if (els.subtitle) {
      els.subtitle.textContent = slide === 'addons'
        ? 'Bring More Smiles to Their Celebration before checkout'
        : 'Add sender details before checkout';
    }

    if (slide === 'sender') {
      window.setTimeout(() => {
        if (els.senderName) els.senderName.focus();
      }, 150);
    }
  };

  const getSelectedVariantId = form => {
    const input = form.querySelector('[name="id"]');
    return input ? Number(input.value) : 0;
  };

  const openPopup = async form => {
    state.activeForm = form;
    state.currentProductVariantId = getSelectedVariantId(form);
    state.currentProductHandle = getCurrentProductHandleFromUrl();

    resetSender();
    setSlide('addons');
    updateSummary();
    setStatus('');

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('og-addon-lock');

    await loadProducts(true);
  };

  const closePopup = async options => {
    const opts = options || {};
    const shouldOpenCart = opts.openCart === true;

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');

    state.activeForm = null;
    state.adding = false;

    unlockPage();

    if (shouldOpenCart && config.openCartDrawerOnPopupClose) {
      window.setTimeout(() => {
        openCartAfterAdd(false);
      }, 120);
    }
  };

  const getCollectionHandle = () => {
    if (config.collectionHandle) return String(config.collectionHandle).trim();

    if (config.currentProductIsCourier) return 'addons-courier';
    if (config.currentProductIsExpress) return 'addons';

    return '';
  };

  const fetchCollectionProducts = async handle => {
    const products = [];
    const limit = Number(config.maxAddonsProductsToShow || 24);
    const perPage = 250;
    let page = 1;

    while (products.length < limit && page <= 4) {
      const url = config.collectionProductsJsonUrl && page === 1
        ? `${config.collectionProductsJsonUrl}${config.collectionProductsJsonUrl.includes('?') ? '&' : '?'}limit=${perPage}&_=${Date.now()}`
        : apiUrl(`/collections/${encodeURIComponent(handle)}/products.json?limit=${perPage}&page=${page}&_=${Date.now()}`);

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Unable to load addon products.');
      }

      const data = await response.json();
      const batch = Array.isArray(data.products) ? data.products : [];

      if (!batch.length) break;

      products.push(...batch);

      if (batch.length < perPage) break;

      page += 1;
    }

    return products;
  };

  const loadProducts = async forceRender => {
    if (state.loaded && !forceRender) return;
    if (state.loading) return;

    state.loading = true;

    show(els.loading);
    hide(els.empty);
    setStatus('');

    try {
      const handle = getCollectionHandle();
      const limit = Number(config.maxAddonsProductsToShow || 24);

      if (!handle) {
        throw new Error('Addon collection handle missing.');
      }

      state.addonVariantIds.clear();

      const rawProducts = await fetchCollectionProducts(handle);

      state.products = rawProducts
        .map(product => {
          const variant = getAvailableVariant(product);

          if (!variant || !variant.available) return null;

          const variantId = Number(variant.id);

          state.addonVariantIds.add(variantId);

          return {
            id: Number(product.id),
            handle: String(product.handle || ''),
            title: product.title,
            image: getImage(product),
            variantId,
            price: getProductPrice(product),
            available: Boolean(variant.available)
          };
        })
        .filter(Boolean)
        .slice(0, limit);

      state.loaded = true;

      renderProducts();
    } catch (error) {
      console.error('[OG Addon] Product fetch error:', error);
      setStatus(error.message || 'Add-ons could not be loaded.', 'error');
    } finally {
      state.loading = false;
      hide(els.loading);
    }
  };

  const getFilteredAddonProducts = () => {
    const currentVariantId = Number(state.currentProductVariantId || 0);
    const currentHandle = String(state.currentProductHandle || '').trim();

    return state.products.filter(product => {
      if (!product || !product.variantId) return false;

      if (currentVariantId && Number(product.variantId) === currentVariantId) {
        return false;
      }

      if (currentHandle && String(product.handle || '') === currentHandle) {
        return false;
      }

      return true;
    });
  };

  const renderProducts = () => {
    if (!els.grid) return;

    els.grid.innerHTML = '';

    const products = getFilteredAddonProducts();

    if (!products.length) {
      show(els.empty);
      updateSummary();
      return;
    }

    hide(els.empty);

    const badges = ['Best Seller', 'Most Added', 'Recommended', 'Popular'];

    products.forEach((product, index) => {
      const card = document.createElement('article');

      card.className = 'og-addon__card';
      card.dataset.variantId = String(product.variantId);

      card.innerHTML = `
        <div class="og-addon__image-wrap">
          ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
          ${index < 4 ? `<span class="og-addon__badge">${badges[index]}</span>` : ''}
        </div>

        <div class="og-addon__info">
          <h3 class="og-addon__title">${escapeHtml(product.title)}</h3>

          <div class="og-addon__meta">
            <strong class="og-addon__price">${formatMoney(product.price)}</strong>
            <button class="og-addon__select" type="button" aria-pressed="false">+ Add</button>
          </div>
        </div>
      `;

      card.addEventListener('click', event => {
        event.preventDefault();
        toggleAddon(product);
      });

      els.grid.appendChild(card);
    });

    updateSelectedCards();
    updateSummary();
  };

  const toggleAddon = product => {
    const id = Number(product.variantId);

    if (state.selected.has(id)) {
      state.selected.delete(id);
    } else {
      if (
        Number(config.maxAddonsSelectable) > 0 &&
        state.selected.size >= Number(config.maxAddonsSelectable)
      ) {
        setStatus(`Maximum ${config.maxAddonsSelectable} add-ons can be selected.`, 'error');
        return;
      }

      state.selected.set(id, product);
    }

    setStatus('');
    updateSelectedCards();
    updateSummary();
  };

  const updateSelectedCards = () => {
    $$('.og-addon__card', popup).forEach(card => {
      const variantId = Number(card.dataset.variantId);
      const selected = state.selected.has(variantId);
      const button = $('.og-addon__select', card);

      card.classList.toggle('is-selected', selected);

      if (button) {
        button.textContent = selected ? 'Added ✓' : '+ Add';
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    });
  };

  const updateSummary = () => {
    const count = state.selected.size;

    const total = Array.from(state.selected.values()).reduce((sum, item) => {
      return sum + normalizePrice(item.price);
    }, 0);

    if (els.count) {
      els.count.textContent = `${count} Add-on${count === 1 ? '' : 's'} Selected`;
    }

    if (els.extra) {
      els.extra.textContent = `Extra ${formatMoney(total)}`;
    }
  };

  const isCodeLikeText = value => {
    return /localStorage|getItem|setItem|function|=>|const |let |var |return |if\s*\(|document\.|window\.|\{|\}/i.test(String(value || ''));
  };

  const cleanValue = value => {
    let text = normalizeText(value);

    if (!text || isCodeLikeText(text)) return '';

    text = text
      .replace(/^[\s:.-]+/, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text || isCodeLikeText(text)) return '';

    return text;
  };

  const addPropIfFilled = (props, key, value) => {
    const cleanKey = String(key || '').trim();
    const cleanVal = cleanValue(value);

    if (!cleanKey || !cleanVal) return;

    props[cleanKey] = cleanVal;
  };

  const getLineItemPropertiesFromScope = scope => {
    const properties = {};

    if (!scope) return properties;

    const formData = scope.tagName === 'FORM' ? new FormData(scope) : null;

    if (formData) {
      for (const [name, value] of formData.entries()) {
        const match = String(name).match(/^properties\[(.+)]$/);

        if (!match) continue;

        addPropIfFilled(properties, match[1], value);
      }
    }

    $$('[data-og-property-name]', scope).forEach(input => {
      addPropIfFilled(properties, input.dataset.ogPropertyName, input.value);
    });

    $$('[name^="properties["]', scope).forEach(input => {
      const match = String(input.name || '').match(/^properties\[(.+)]$/);
      if (!match) return;

      addPropIfFilled(properties, match[1], input.value);
    });

    return properties;
  };

  const readValueBySelectors = selectors => {
    for (const selector of selectors) {
      const node = document.querySelector(selector);

      if (!node) continue;

      const value =
        node.value ||
        node.getAttribute('value') ||
        node.dataset.value ||
        node.textContent ||
        '';

      const clean = cleanValue(value);

      if (clean || clean === '0') return clean;
    }

    return '';
  };

  const getSummaryText = () => {
    const nodes = $$(
      '.og-selected-delivery, [data-og-selected-delivery], .og-delivery-summary, .og-delivery-selected, [class*="selected"][class*="delivery"], [class*="delivery"][class*="summary"], #ogDeliveryWidget, .og-delivery-widget'
    );

    return nodes
      .map(node => normalizeText(node.textContent || ''))
      .filter(Boolean)
      .join(' | ');
  };

  const extractByLabel = (text, label) => {
    const raw = normalizeText(text);
    if (!raw) return '';

    const labels = [
      'Delivery City',
      'Delivery Pincode',
      'Delivery Date',
      'Delivery Type',
      'Delivery Slot',
      'Delivery Charge',
      'Delivery Fee',
      'Final Delivery Charge',
      'Remote Charge',
      'Sender Name',
      'Sender Phone Number',
      'Message with Order'
    ];

    const escapedLabel = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const otherLabels = labels
      .filter(item => item !== label)
      .map(item => item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|');

    const regex = new RegExp(`${escapedLabel}\\s*:?\\s*(.*?)(?=\\s*(?:${otherLabels})\\s*:?|$)`, 'i');
    const match = raw.match(regex);

    if (!match || !match[1]) return '';

    return cleanValue(match[1]);
  };

  const cleanDateText = value => {
    let text = cleanValue(value);

    if (!text) return '';

    text = text
      .replace(/^Delivery Date\s*:?\s*/i, '')
      .replace(/\bDelivery Type\b.*$/i, '')
      .replace(/\bDelivery Slot\b.*$/i, '')
      .replace(/\bDelivery Charge\b.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text || isCodeLikeText(text)) return '';

    const ddmmyyyy = text.match(/\b\d{1,2}[-/]\d{1,2}[-/]\d{2,4}\b/);
    if (ddmmyyyy) return ddmmyyyy[0];

    const todayTomorrow = text.match(/\b(Today|Tomorrow)\b[\s,]*(Mon|Tue|Wed|Thu|Fri|Sat|Sun)?[\s,]*\d{1,2}[\s,]*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)?/i);
    if (todayTomorrow) return normalizeText(todayTomorrow[0]);

    const monthDate = text.match(/\b\d{1,2}\s*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s*,?\s*\d{2,4}?\b/i);
    if (monthDate) return normalizeText(monthDate[0]);

    return text.length <= 40 ? text : '';
  };

  const cleanDeliveryTypeText = text => {
    const clean = normalizeText(text);

    if (/morning/i.test(clean)) return 'Morning Delivery';
    if (/express/i.test(clean)) return 'Express Delivery';
    if (/standard/i.test(clean)) return 'Standard Delivery';
    if (/fixed/i.test(clean)) return 'Fixed Time Delivery';
    if (/midnight/i.test(clean)) return 'Midnight Delivery';
    if (/remote/i.test(clean)) return 'Remote Delivery';
    if (/next/i.test(clean)) return 'Next Day Delivery';

    return cleanValue(clean);
  };

  const cleanSlotText = text => {
    const clean = cleanValue(text);
    if (!clean) return '';

    const range1 = clean.match(/\b\d{1,2}:\d{2}\s*(AM|PM)\s*[-–]\s*\d{1,2}:\d{2}\s*(AM|PM)\b/i);
    if (range1) return normalizeText(range1[0]);

    const range2 = clean.match(/\b\d{1,2}\s*(AM|PM)\s*[-–]\s*\d{1,2}\s*(AM|PM)\b/i);
    if (range2) return normalizeText(range2[0]);

    const single = clean.match(/\b\d{1,2}:\d{2}\s*(AM|PM)\b/i);
    if (single) return normalizeText(single[0]);

    return clean;
  };

  const getSelectedLocation = () => {
    const directCity = readValueBySelectors([
      '[name="properties[Delivery City]"]',
      '[data-og-property-name="Delivery City"]'
    ]);

    const directPin = readValueBySelectors([
      '[name="properties[Delivery Pincode]"]',
      '[data-og-property-name="Delivery Pincode"]'
    ]);

    const summaryText = getSummaryText();

    const cityFromSummary = extractByLabel(summaryText, 'Delivery City');
    const pinFromSummary = extractByLabel(summaryText, 'Delivery Pincode');

    const rawLocation = readValueBySelectors([
      '#ogLocationInput',
      '[data-og-location-input]',
      '.og-location-input',
      '.og-delivery-location input',
      '.og-delivery-widget input[type="text"]',
      '.og-delivery-widget input[type="search"]',
      '.og-delivery-widget input[type="tel"]',
      'input[placeholder*="pincode" i]',
      'input[placeholder*="city" i]',
      'input[placeholder*="location" i]'
    ]);

    const result = {
      city: directCity || cityFromSummary || '',
      pincode: directPin || pinFromSummary || ''
    };

    const source = `${directCity} ${directPin} ${summaryText} ${rawLocation}`;
    const pinMatch = source.match(/\b\d{6}\b/);

    if (!result.pincode && pinMatch) {
      result.pincode = pinMatch[0];
    }

    if (!result.city && rawLocation) {
      result.city = rawLocation
        .replace(/\b\d{6}\b/g, '')
        .replace(/[,|-]/g, ' ')
        .replace(/\bIND\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    return result;
  };

  const getSelectedDateText = () => {
    const hiddenValue = readValueBySelectors([
      '[name="properties[Delivery Date]"]',
      '[data-og-property-name="Delivery Date"]',
      '[data-og-delivery-date]'
    ]);

    const cleanHidden = cleanDateText(hiddenValue);
    if (cleanHidden) return cleanHidden;

    const summaryText = getSummaryText();
    const fromSummary = cleanDateText(extractByLabel(summaryText, 'Delivery Date'));
    if (fromSummary) return fromSummary;

    const selectedDateNode = document.querySelector(
      '.og-date-card.is-selected, .og-date-card.selected, .og-delivery-date .is-selected, .og-delivery-date [aria-pressed="true"], .og-delivery-date [aria-selected="true"], [class*="date"] .is-selected, [class*="date"] [aria-pressed="true"]'
    );

    if (selectedDateNode) {
      const cleanSelected = cleanDateText(selectedDateNode.textContent || selectedDateNode.value || '');
      if (cleanSelected) return cleanSelected;
    }

    return '';
  };

  const getSelectedDeliveryType = () => {
    const direct = readValueBySelectors([
      '[name="properties[Delivery Type]"]',
      '[data-og-property-name="Delivery Type"]',
      '[data-og-delivery-type]'
    ]);

    if (direct) return cleanDeliveryTypeText(direct);

    const summaryText = getSummaryText();
    const fromSummary = extractByLabel(summaryText, 'Delivery Type');
    if (fromSummary) return cleanDeliveryTypeText(fromSummary);

    const checked =
      document.querySelector('.og-delivery_type-slot-grid input:checked') ||
      document.querySelector('.og-delivery-type-slot-grid input:checked') ||
      document.querySelector('.og-slot-card__radio:checked') ||
      document.querySelector('input[name*="Delivery Type"]:checked') ||
      document.querySelector('input[name*="delivery_type"]:checked') ||
      document.querySelector('input[name*="delivery-type"]:checked');

    if (checked) {
      const card = checked.closest('label, .og-slot-card, .delivery-option, .product-form__input, [class*="delivery"]');
      const text = normalizeText(card ? card.textContent : checked.value);
      return cleanDeliveryTypeText(text);
    }

    return '';
  };

  const getSelectedDeliverySlot = () => {
    const direct = readValueBySelectors([
      '[name="properties[Delivery Slot]"]',
      '[data-og-property-name="Delivery Slot"]',
      '[data-og-delivery-slot]'
    ]);

    if (direct) return cleanSlotText(direct);

    const summaryText = getSummaryText();
    const fromSummary = extractByLabel(summaryText, 'Delivery Slot');
    if (fromSummary) return cleanSlotText(fromSummary);

    const checked =
      document.querySelector('#ogSlotOptions input:checked') ||
      document.querySelector('.og-slot-options input:checked') ||
      document.querySelector('.og-delivery-slot input:checked') ||
      document.querySelector('input[name*="Delivery Slot"]:checked') ||
      document.querySelector('input[name*="delivery_slot"]:checked') ||
      document.querySelector('input[name*="delivery-slot"]:checked');

    if (checked) {
      const card = checked.closest('label, .og-slot-card, .delivery-slot, .product-form__input, [class*="slot"]');
      return cleanSlotText(card ? card.textContent : checked.value);
    }

    return '';
  };

  const getDatasetNumber = node => {
    if (!node || !node.dataset) return 0;

    const keys = [
      'ogSelectedDeliveryFeeAmount',
      'ogDeliveryFee',
      'ogDeliveryCharge',
      'ogDeliveryAmount',
      'deliveryFee',
      'deliveryCharge',
      'deliveryAmount',
      'fee',
      'charge',
      'amount',
      'price'
    ];

    for (const key of keys) {
      if (node.dataset[key] === undefined) continue;

      const amount = Math.round(normalizePrice(node.dataset[key]));

      if (amount > 0) return amount;
    }

    return 0;
  };

  const getSelectedDeliveryCard = () => {
    return (
      document.querySelector('.og-slot-card.is-selected') ||
      document.querySelector('.og-slot-card.selected') ||
      document.querySelector('.og-delivery-option.is-selected') ||
      document.querySelector('.og-delivery-option.selected') ||
      document.querySelector('.og-delivery-card.is-selected') ||
      document.querySelector('.og-delivery-card.selected') ||
      document.querySelector('[data-og-delivery-type].is-selected') ||
      document.querySelector('[data-og-delivery-type].selected') ||
      document.querySelector('[class*="delivery"] [aria-pressed="true"]') ||
      document.querySelector('[class*="delivery"] [aria-selected="true"]') ||
      document.querySelector('.og-delivery_type-slot-grid input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('.og-delivery-type-slot-grid input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('#ogSlotOptions input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('.og-slot-options input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      null
    );
  };

  const getAmountFromText = text => {
    const clean = normalizeText(text || '');

    if (!clean) return 0;

    if (/free/i.test(clean)) return 0;

    const rupeeMatches = clean.match(/₹\s*([0-9,]+)/g);

    if (rupeeMatches && rupeeMatches.length) {
      const last = rupeeMatches[rupeeMatches.length - 1];
      const amount = Math.round(normalizePrice(last));

      if (amount > 0) return amount;
    }

    const chargeMatch = clean.match(/(?:delivery\s*(?:charge|fee)|final\s*delivery\s*charge|remote\s*charge|extra|charge|fee)\s*:?\s*₹?\s*([0-9,]+)/i);

    if (chargeMatch && chargeMatch[1]) {
      const amount = Math.round(normalizePrice(chargeMatch[1]));

      if (amount > 0) return amount;
    }

    return 0;
  };

  const getAmountFromDeliveryTypeFallback = () => {
    const typeText = normalizeLower(getSelectedDeliveryType());
    const fallback = config.deliveryFeeFallbackByType || {};

    if (!typeText) return 0;

    const entries = Object.entries(fallback).sort((a, b) => b[0].length - a[0].length);

    for (const [key, value] of entries) {
      const cleanKey = normalizeLower(key);

      if (cleanKey && typeText.includes(cleanKey)) {
        return Math.round(Number(value || 0));
      }
    }

    if (typeText.includes('midnight')) return 349;
    if (typeText.includes('fixed')) return 249;
    if (typeText.includes('morning')) return 299;
    if (typeText.includes('express')) return 49;
    if (typeText.includes('standard')) return 0;

    if (typeText.includes('remote')) return 0;
    if (typeText.includes('next')) return 0;

    return 0;
  };

  const getDeliveryFeeAmountFromPage = () => {
    const forcedAmount = readValueBySelectors([
      '[name="properties[_og_selected_delivery_fee_amount]"]',
      '[name="properties[_og_delivery_fee_amount]"]',
      '[name="properties[Delivery Charge]"]',
      '[name="properties[Delivery Fee]"]',
      '[name="properties[Final Delivery Charge]"]',
      '[name="properties[Remote Charge]"]',
      '#OgSelectedDeliveryFeeAmount',
      '[data-og-selected-delivery-fee-amount]',
      '[data-og-delivery-charge]',
      '[data-og-delivery-fee]',
      '[data-og-delivery-amount]',
      '[data-delivery-charge]',
      '[data-delivery-fee]',
      '[data-delivery-amount]'
    ]);

    if (forcedAmount || forcedAmount === '0') {
      const amount = Math.round(normalizePrice(forcedAmount));

      if (amount >= 0) return amount;
    }

    const selectedCard = getSelectedDeliveryCard();

    if (selectedCard) {
      const cardText = normalizeText(selectedCard.textContent || '');

      if (/free|standard/i.test(cardText)) return 0;

      const datasetAmount = getDatasetNumber(selectedCard);
      if (datasetAmount > 0) return datasetAmount;

      const input = selectedCard.querySelector('input:checked, input[type="radio"], input[type="hidden"]');

      if (input) {
        const inputDatasetAmount = getDatasetNumber(input);

        if (inputDatasetAmount > 0) return inputDatasetAmount;

        const inputValueAmount = getAmountFromText(input.value || '');

        if (inputValueAmount > 0) return inputValueAmount;
      }

      const cardAmountMatch = cardText.match(/₹\s*([0-9,]+)/);

      if (cardAmountMatch && cardAmountMatch[1]) {
        const amount = Math.round(normalizePrice(cardAmountMatch[1]));
        if (amount > 0) return amount;
      }

      const cardTextAmount = getAmountFromText(cardText);

      if (cardTextAmount > 0) return cardTextAmount;
    }

    const summaryText = getSummaryText();

    const labeledValues = [
      extractByLabel(summaryText, 'Delivery Charge'),
      extractByLabel(summaryText, 'Delivery Fee'),
      extractByLabel(summaryText, 'Final Delivery Charge'),
      extractByLabel(summaryText, 'Remote Charge')
    ];

    for (const value of labeledValues) {
      const amount = getAmountFromText(value);
      if (amount > 0) return amount;
    }

    const summaryAmount = getAmountFromText(summaryText);

    if (summaryAmount > 0) return summaryAmount;

    return getAmountFromDeliveryTypeFallback();
  };

  const getDeliveryFeeVariantId = amount => {
    const map = config.deliveryFeeVariantByAmount || {};
    const cleanAmount = String(Math.round(Number(amount || 0)));

    if (map[cleanAmount]) return Number(map[cleanAmount]);

    const numericKeys = Object.keys(map)
      .map(key => Number(key))
      .filter(num => Number.isFinite(num));

    const exact = numericKeys.find(num => Number(num) === Number(cleanAmount));

    if (exact !== undefined && map[String(exact)]) return Number(map[String(exact)]);

    return 0;
  };

  const getDeliveryPropertiesFromPage = () => {
    const props = {};

    const formProps = getLineItemPropertiesFromScope(state.activeForm);

    [
      'Delivery City',
      'Delivery Pincode',
      'Delivery Date',
      'Delivery Type',
      'Delivery Slot'
    ].forEach(key => {
      if (formProps[key]) props[key] = formProps[key];
    });

    const location = getSelectedLocation();

    if (!props['Delivery City'] && location.city) {
      props['Delivery City'] = location.city;
    }

    if (!props['Delivery Pincode'] && location.pincode) {
      props['Delivery Pincode'] = location.pincode;
    }

    const dateText = cleanDateText(props['Delivery Date']) || getSelectedDateText();

    if (dateText) {
      props['Delivery Date'] = dateText;
    } else {
      delete props['Delivery Date'];
    }

    const typeText = cleanDeliveryTypeText(props['Delivery Type']) || getSelectedDeliveryType();

    if (typeText) {
      props['Delivery Type'] = typeText;
    } else {
      delete props['Delivery Type'];
    }

    const slotText = cleanSlotText(props['Delivery Slot']) || getSelectedDeliverySlot();

    if (slotText) {
      props['Delivery Slot'] = slotText;
    } else {
      delete props['Delivery Slot'];
    }

    return props;
  };

  const validateDeliverySelection = () => {
    if (!config.requireDeliverySelection) return true;
    if (config.currentProductIsCourier) return true;

    const deliveryProps = getDeliveryPropertiesFromPage();

    if (
      deliveryProps['Delivery City'] ||
      deliveryProps['Delivery Pincode'] ||
      deliveryProps['Delivery Date'] ||
      deliveryProps['Delivery Type'] ||
      deliveryProps['Delivery Slot']
    ) {
      return true;
    }

    const firstDeliveryArea =
      document.querySelector('.og-delivery-widget, #ogDeliveryWidget') ||
      document.querySelector('[class*="delivery"]');

    if (firstDeliveryArea && typeof firstDeliveryArea.scrollIntoView === 'function') {
      firstDeliveryArea.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    alert('Please select delivery date and time slot first.');
    return false;
  };

  const validateOptisRequiredOptions = form => {
    if (!config.requireOptisRequiredOptions) return true;

    const scope =
      form?.closest('.product, .product__info-wrapper, .product__info-container, [id*="MainProduct"], main') ||
      document.querySelector('.product, .product__info-wrapper, .product__info-container, [id*="MainProduct"]') ||
      document;

    const clean = value => String(value || '').replace(/\s+/g, ' ').trim();

    const cssEscapeSafe = value => {
      if (window.CSS && CSS.escape) return CSS.escape(value);
      return String(value || '').replace(/["\\]/g, '\\$&');
    };

    const isNodeVisible = el => {
      if (!el) return false;

      if (
        el.closest('[hidden], [aria-hidden="true"], #OgAddonPopup, .og-addon, #CartDrawer, cart-drawer, header, footer')
      ) {
        return false;
      }

      const style = window.getComputedStyle(el);
      if (!style || style.display === 'none' || style.visibility === 'hidden') return false;

      const rect = el.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0;
    };

    const getWrapper = field => {
      return (
        field.closest(
          '.po-group, .po-option, .po-option-field, .po-field, .product-option, .product-form__input, .field, .form-field, [data-option-group], [data-po-group], [class*="option"], [class*="upload"]'
        ) ||
        field.parentElement ||
        field
      );
    };

    const getLabelText = field => {
      if (!field) return '';

      if (field.id) {
        const label = document.querySelector(`label[for="${cssEscapeSafe(field.id)}"]`);
        if (label && clean(label.textContent)) return clean(label.textContent);
      }

      const wrapper = getWrapper(field);

      const labelNode = wrapper.querySelector?.(
        'label, legend, .po-label, .po-title, .po-option-label, .form__label, [class*="label"], [class*="title"]'
      );

      if (labelNode && clean(labelNode.textContent)) return clean(labelNode.textContent);

      return clean(wrapper.textContent || field.placeholder || field.name || '');
    };

    const getPropertyName = field => {
      const match = String(field.name || '').match(/properties\[(.+)]/i);
      return match && match[1] ? clean(match[1]) : '';
    };

    const shouldIgnore = field => {
      const type = String(field.type || '').toLowerCase();
      const name = String(field.name || '').toLowerCase();
      const id = String(field.id || '').toLowerCase();
      const cls = String(field.className || '').toLowerCase();
      const placeholder = String(field.placeholder || '').toLowerCase();

      if (field.disabled || field.readOnly) return true;
      if (['submit', 'button', 'reset'].includes(type)) return true;
      if (['id', 'quantity', 'selling_plan', 'form_type', 'utf8'].includes(name)) return true;

      if (
        name.includes('delivery') ||
        id.includes('delivery') ||
        cls.includes('delivery') ||
        placeholder.includes('city') ||
        placeholder.includes('pincode') ||
        placeholder.includes('location') ||
        placeholder.includes('search') ||
        name.includes('sender') ||
        name.includes('message')
      ) {
        return true;
      }

      if (
        field.closest('#OgAddonPopup') ||
        field.closest('.og-addon') ||
        field.closest('#CartDrawer') ||
        field.closest('cart-drawer') ||
        field.closest('header') ||
        field.closest('footer') ||
        field.closest('[class*="search"]')
      ) {
        return true;
      }

      return false;
    };

    const isRequiredField = field => {
      if (!field || shouldIgnore(field)) return false;

      const type = String(field.type || '').toLowerCase();
      const wrapper = getWrapper(field);

      if (type !== 'file' && type !== 'hidden' && !isNodeVisible(field)) return false;
      if ((type === 'file' || type === 'hidden') && !isNodeVisible(wrapper)) return false;

      const labelText = getLabelText(field);
      const wrapperText = clean(wrapper?.textContent || '');
      const propName = getPropertyName(field);

      if (
        field.required ||
        field.getAttribute('aria-required') === 'true' ||
        field.getAttribute('data-required') === 'true' ||
        field.getAttribute('data-is-required') === 'true' ||
        field.getAttribute('data-po-required') === 'true'
      ) {
        return true;
      }

      if (
        labelText.includes('*') ||
        wrapperText.includes('*') ||
        /\brequired\b/i.test(labelText) ||
        /\brequired\b/i.test(wrapperText)
      ) {
        return true;
      }

      if (
        /^properties\[/i.test(String(field.name || '')) &&
        propName &&
        !/delivery|sender|message/i.test(propName)
      ) {
        return true;
      }

      return false;
    };

    const isBlankField = field => {
      const type = String(field.type || '').toLowerCase();
      const tag = String(field.tagName || '').toLowerCase();
      const wrapper = getWrapper(field);

      if (type === 'radio' || type === 'checkbox') {
        const groupScope = field.closest('form') || scope;

        if (field.name) {
          return !groupScope.querySelector(`[name="${cssEscapeSafe(field.name)}"]:checked`);
        }

        return !field.checked;
      }

      if (type === 'file') {
        if (field.files && field.files.length > 0) return false;

        const uploadedText = clean(wrapper.textContent || '');

        if (
          /uploaded|selected|remove|change|replace|file selected|image selected/i.test(uploadedText) &&
          !/choose file|drop file to upload|or drop file|no file/i.test(uploadedText)
        ) {
          return false;
        }

        const preview =
          wrapper.querySelector('img[src]:not([src=""])') ||
          wrapper.querySelector('[class*="preview"]') ||
          wrapper.querySelector('[class*="uploaded"]') ||
          wrapper.querySelector('[data-file], [data-uploaded], [data-preview]');

        if (preview) return false;

        return true;
      }

      if (tag === 'select') {
        return !clean(field.value);
      }

      if (type === 'hidden') {
        const val = clean(field.value);

        if (val) return false;

        const uploadedText = clean(wrapper.textContent || '');

        if (
          /uploaded|selected|remove|change|replace|file selected|image selected/i.test(uploadedText) &&
          !/choose file|drop file to upload|or drop file|no file/i.test(uploadedText)
        ) {
          return false;
        }

        const fileInput = wrapper.querySelector('input[type="file"]');
        if (fileInput && fileInput.files && fileInput.files.length > 0) return false;

        const preview =
          wrapper.querySelector('img[src]:not([src=""])') ||
          wrapper.querySelector('[class*="preview"]') ||
          wrapper.querySelector('[class*="uploaded"]') ||
          wrapper.querySelector('[data-file], [data-uploaded], [data-preview]');

        if (preview) return false;

        return true;
      }

      return !clean(field.value);
    };

    const showError = field => {
      const wrapper = getWrapper(field);

      wrapper.classList.add('og-option-required-error');

      if (!wrapper.querySelector('.og-option-required-message')) {
        const msg = document.createElement('div');
        msg.className = 'og-option-required-message';
        msg.textContent = 'Please fill this required option.';
        wrapper.appendChild(msg);
      }

      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      if (String(field.type || '').toLowerCase() !== 'hidden') {
        setTimeout(() => {
          try {
            field.focus({ preventScroll: true });
          } catch (error) {
            if (typeof field.focus === 'function') field.focus();
          }
        }, 200);
      }

      setTimeout(() => {
        wrapper.classList.remove('og-option-required-error');
      }, 3000);
    };

    const requiredFields = Array.from(scope.querySelectorAll('input, textarea, select'))
      .filter(isRequiredField);

    for (const field of requiredFields) {
      if (!isBlankField(field)) continue;

      const label = getLabelText(field)
        .replace(/\*/g, '')
        .replace(/\brequired\b/ig, '')
        .replace(/choose file/ig, '')
        .replace(/or drop file to upload/ig, '')
        .trim();

      showError(field);

      alert(`Please fill required option${label ? `: ${label}` : ''}`);

      return false;
    }

    return true;
  };

  const validateProductForm = form => {
    if (!form) return false;

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      }

      return false;
    }

    const variantInput = form.querySelector('[name="id"]');

    if (!variantInput || !variantInput.value) {
      alert('Please select product option first.');
      return false;
    }

    if (!validateOptisRequiredOptions(form)) {
      return false;
    }

    if (!validateDeliverySelection()) {
      return false;
    }

    return true;
  };

   const validateSender = () => {
  clearSenderErrors();

  const name = String(els.senderName?.value || '').trim();
  const phone = String(els.senderPhone?.value || '').trim();
  const message = String(els.senderMessage?.value || '').trim();

  let valid = true;

  if (config.requireSenderName && name.length < 2) {
    setSenderError('sender_name', 'Please enter sender name.');
    valid = false;
  }

  if (config.requireMessage && message.length < 2) {
    setSenderError('message', 'Please enter your message.');
    valid = false;
  }

  return {
    valid,
    values: {
      senderName: name,
      senderPhone: phone,
      message
    }
  };
};

  const getQuantity = form => {
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);

    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const getSellingPlan = form => {
    const input = form.querySelector('[name="selling_plan"]');
    return input && input.value ? input.value : null;
  };

  const getAllParentProperties = form => {
    return {
      ...getLineItemPropertiesFromScope(form),
      ...getDeliveryPropertiesFromPage()
    };
  };

  const getParentTitle = () => {
    const titleNode =
      $('[data-product-title]') ||
      $('.product__title') ||
      $('h1');

    return titleNode
      ? titleNode.textContent.trim()
      : document.title.replace(/\s*[-|].*$/, '').trim();
  };

  const postJson = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = data.description || data.message || 'Something went wrong.';
      throw new Error(message);
    }

    return data;
  };

  const buildVisibleSenderProperties = senderValues => {
    const props = {};

    if (senderValues.senderName) {
      props['Sender Name'] = senderValues.senderName;
    }

    if (senderValues.senderPhone) {
      props['Sender Phone Number'] = senderValues.senderPhone;
    }

    if (senderValues.message) {
      props['Message with Order'] = senderValues.message;
    }

    return props;
  };

  const getParentType = () => {
    if (config.currentProductIsCourier) return 'courier';
    return 'express';
  };

  const buildDeliveryFeeItem = (groupId, parentVariantId) => {
    if (!config.enableDeliveryFeeItem) return null;
    if (config.currentProductIsCourier) return null;

    const amount = getDeliveryFeeAmountFromPage();
    const roundedAmount = Math.round(Number(amount || 0));

    if (!roundedAmount || roundedAmount <= 0) return null;

    const feeVariantId = getDeliveryFeeVariantId(roundedAmount);

    if (!feeVariantId) {
      console.warn('[OG Addon] Delivery fee amount detected but variant id missing:', roundedAmount);
      return null;
    }

    return {
      id: feeVariantId,
      quantity: 1,
      properties: {
        'Delivery Fee': `${config.currencySymbol}${roundedAmount}`,
        '_og_delivery_fee': 'true',
        '_og_delivery_fee_amount': String(roundedAmount),
        '_og_delivery_fee_product_id': String(config.deliveryFeeProductId || ''),
        '_og_delivery_fee_group_id': groupId,
        '_og_delivery_fee_parent_variant_id': String(parentVariantId),
        '_og_parent_type': getParentType()
      }
    };
  };

  const addItemsToCart = async senderValues => {
    const form = state.activeForm;

    if (!form) {
      throw new Error('Product form not found.');
    }

    const parentVariantId = getSelectedVariantId(form);
    const parentQuantity = getQuantity(form);
    const sellingPlan = getSellingPlan(form);

    const groupId = `og_addon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const selectedAddons = Array.from(state.selected.values());
    const visibleSenderProps = buildVisibleSenderProperties(senderValues);
    const deliveryFeeAmount = getDeliveryFeeAmountFromPage();
    const parentType = getParentType();

    const parentProperties = {
      ...getAllParentProperties(form),
      ...visibleSenderProps,
      '_addon_group_id': groupId,
      '_has_addons': selectedAddons.length ? 'true' : 'false',
      '_og_parent_type': parentType,
      '_addon_parent_type': parentType
    };

    if (deliveryFeeAmount && Number(deliveryFeeAmount) > 0) {
      parentProperties['_og_delivery_fee_amount'] = String(Math.round(Number(deliveryFeeAmount)));
    }

    if (parentProperties['Delivery Date']) {
      const cleanDate = cleanDateText(parentProperties['Delivery Date']);

      if (cleanDate) {
        parentProperties['Delivery Date'] = cleanDate;
      } else {
        delete parentProperties['Delivery Date'];
      }
    }

    const parentItem = {
      id: parentVariantId,
      quantity: parentQuantity,
      properties: parentProperties
    };

    if (sellingPlan) {
      parentItem.selling_plan = sellingPlan;
    }

    const deliveryFeeItem = buildDeliveryFeeItem(groupId, parentVariantId);

    const addonItems = selectedAddons
      .filter(addon => Number(addon.variantId) !== Number(parentVariantId))
      .map(addon => {
        return {
          id: addon.variantId,
          quantity: parentQuantity,
          properties: {
            '_addon_item': 'true',
            '_addon_group_id': groupId,
            '_addon_for_product': getParentTitle(),
            '_addon_parent_variant_id': String(parentVariantId),
            '_addon_parent_key': `pending_${groupId}`,
            '_addon_parent_type': parentType
          }
        };
      });

    const items = [parentItem];

    if (deliveryFeeItem) {
      items.push(deliveryFeeItem);
    }

    items.push(...addonItems);

    const added = await postJson(apiUrl('/cart/add.js'), {
      items
    });

    await patchAddonParentKey(added, groupId);
    await cleanupCart();

    return added;
  };

  const patchAddonParentKey = async (addedResponse, groupId) => {
    const items = Array.isArray(addedResponse.items) ? addedResponse.items : [];

    if (items.length < 2) return;

    const parentKey = items[0] && items[0].key;

    if (!parentKey) return;

    const childItems = items.slice(1);

    for (const item of childItems) {
      if (!item || !item.key) continue;

      const oldProps = item.properties || {};
      const isAddon = String(oldProps._addon_item || '').toLowerCase() === 'true';

      if (!isAddon) continue;

      const properties = {
        ...oldProps,
        '_addon_parent_key': parentKey,
        '_addon_group_id': groupId,
        '_addon_item': 'true',
        '_addon_parent_type': oldProps._addon_parent_type || getParentType()
      };

      try {
        await postJson(apiUrl('/cart/change.js'), {
          id: item.key,
          quantity: item.quantity,
          properties
        });
      } catch (error) {
        console.warn('[OG Addon] Parent key patch skipped:', error);
      }
    }
  };

  /*
    IMPORTANT NEW CLEANUP LOGIC

    Requirement:
    - Cart me agar ek bhi express parent product bacha hai,
      to express add-ons cart me rahenge.
    - Customer add-ons ko manually ek-ek karke remove kar sakta hai.
    - Jab last express parent product remove ho jaye,
      tab express add-ons auto remove honge.
    - Courier parent ke liye bhi same safe logic.
    - Delivery fee item parent group specific rahega.
  */
  const cleanupCart = async () => {
    if (state.cleaning) return;

    state.cleaning = true;

    try {
      if (!state.loaded && isAddonEnabledProductPage()) {
        await loadProducts(false);
      }

      const response = await fetch(apiUrl('/cart.js'), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];

      const parentGroups = new Map();

      let hasExpressParent = false;
      let hasCourierParent = false;

      items.forEach(item => {
        const properties = item.properties || {};

        const groupId = properties._addon_group_id;
        const isAddon = String(properties._addon_item || '').toLowerCase() === 'true';
        const isDeliveryFee = String(properties._og_delivery_fee || '').toLowerCase() === 'true';

        if (!groupId || isAddon || isDeliveryFee) return;

        parentGroups.set(groupId, {
          quantity: item.quantity,
          item
        });

        const parentType = normalizeLower(
          properties._og_parent_type ||
          properties._addon_parent_type ||
          properties._delivery_source ||
          ''
        );

        const itemText = normalizeLower(
          [
            item.title,
            item.product_title,
            item.vendor,
            item.product_type,
            Object.values(properties || {}).join(' ')
          ].join(' ')
        );

        if (
          parentType.includes('express') ||
          itemText.includes('express') ||
          properties['Delivery Type']?.toLowerCase?.().includes('express')
        ) {
          hasExpressParent = true;
        }

        if (
          parentType.includes('courier') ||
          itemText.includes('courier')
        ) {
          hasCourierParent = true;
        }
      });

      /*
        Backward compatibility:
        Agar old cart parent me _og_parent_type property nahi hai,
        current product page config se parent availability detect karne me help milegi.
      */
      if (config.currentProductIsExpress === true && parentGroups.size > 0) {
        hasExpressParent = true;
      }

      if (config.currentProductIsCourier === true && parentGroups.size > 0) {
        hasCourierParent = true;
      }

      const updates = {};

      items.forEach(item => {
        const properties = item.properties || {};

        const groupId = properties._addon_group_id;
        const feeGroupId = properties._og_delivery_fee_group_id;

        const isAddon = String(properties._addon_item || '').toLowerCase() === 'true';
        const isDeliveryFee = String(properties._og_delivery_fee || '').toLowerCase() === 'true';
        const isKnownAddonVariant = state.addonVariantIds.has(Number(item.variant_id));

        const addonParentType = normalizeLower(
          properties._addon_parent_type ||
          properties._og_parent_type ||
          properties._delivery_source ||
          ''
        );

        const addonText = normalizeLower(
          [
            item.title,
            item.product_title,
            Object.values(properties || {}).join(' ')
          ].join(' ')
        );

        const isExpressRelatedAddon =
          addonParentType.includes('express') ||
          addonText.includes('express') ||
          isKnownAddonVariant;

        const isCourierRelatedAddon =
          addonParentType.includes('courier') ||
          addonText.includes('courier');

        if (isAddon) {
          if (isCourierRelatedAddon) {
            if (!hasCourierParent) {
              updates[item.key] = 0;
            }

            return;
          }

          /*
            Default add-on source express maana gaya hai because normal add-ons
            collection express parent ke sath use hota hai.
          */
          if (isExpressRelatedAddon || !isCourierRelatedAddon) {
            if (!hasExpressParent) {
              updates[item.key] = 0;
            }

            return;
          }

          const parentGroup = groupId ? parentGroups.get(groupId) : null;

          if (!parentGroup && !hasExpressParent && !hasCourierParent) {
            updates[item.key] = 0;
          }

          return;
        }

        if (isDeliveryFee) {
          const feeParentGroup = feeGroupId ? parentGroups.get(feeGroupId) : null;

          if (!feeParentGroup) {
            updates[item.key] = 0;
            return;
          }

          if (item.quantity !== 1) {
            updates[item.key] = 1;
          }

          return;
        }

        /*
          Direct addon product block:
          Agar add-on variant normal product ki tarah add ho gaya hai,
          aur cart me koi parent nahi hai, to remove.
        */
        if (
          config.strictBlockAddonVariants &&
          isKnownAddonVariant &&
          !isAddon
        ) {
          const isCurrentMainProduct =
            Number(item.variant_id) === Number(state.currentProductVariantId);

          if (isCurrentMainProduct) return;

          if (!hasExpressParent && !hasCourierParent) {
            updates[item.key] = 0;
          }
        }
      });

      if (Object.keys(updates).length) {
        await postJson(apiUrl('/cart/update.js'), {
          updates
        });
      }
    } catch (error) {
      console.warn('[OG Addon] Cart cleanup skipped:', error);
    } finally {
      state.cleaning = false;
    }
  };

  const refreshCartSections = async () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('og:cart:refresh', { bubbles: true }));

    try {
      const sections = [
        'cart-drawer',
        'cart-icon-bubble',
        'main-cart-items',
        'cart-footer'
      ];

      const response = await fetch(apiUrl(`/cart?sections=${sections.join(',')}`), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const htmlBySection = await response.json();

      Object.entries(htmlBySection || {}).forEach(([sectionId, html]) => {
        if (!html) return;

        const currentSection = document.getElementById(`shopify-section-${sectionId}`);
        if (!currentSection) return;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const freshSection = temp.querySelector(`#shopify-section-${sectionId}`);

        if (freshSection) {
          currentSection.innerHTML = freshSection.innerHTML;
        }
      });
    } catch (error) {
      console.warn('[OG Addon] Cart section refresh skipped:', error);
    }
  };

  const closeWrongMobileMenu = () => {
    const openedDetails = $$(
      'header-drawer details[open], menu-drawer details[open], .menu-drawer-container details[open], details.menu-opening[open]'
    );

    openedDetails.forEach(details => {
      details.removeAttribute('open');
    });

    $$('header-drawer, menu-drawer, .menu-drawer-container, .mobile-menu, .mega-menu').forEach(node => {
      node.classList.remove('active', 'menu-opening', 'open', 'is-open');
      node.removeAttribute('open');
      node.removeAttribute('aria-expanded');
    });

    document.body.classList.remove('menu-opening', 'overflow-hidden-tablet');
    document.documentElement.classList.remove('menu-opening');
  };

  const openCartAfterAdd = async shouldRefresh => {
    closeWrongMobileMenu();
    unlockPage();

    if (shouldRefresh !== false) {
      await refreshCartSections();
      await new Promise(resolve => setTimeout(resolve, 180));
    }

    const drawer =
      document.querySelector('cart-drawer#CartDrawer') ||
      document.querySelector('#CartDrawer.cart-drawer') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer');

    if (drawer) {
      closeWrongMobileMenu();

      if (typeof drawer.open === 'function') {
        drawer.open();
      }

      drawer.classList.add('active', 'animate');
      drawer.setAttribute('open', '');
      drawer.removeAttribute('hidden');
      drawer.removeAttribute('aria-hidden');

      const inner = drawer.querySelector('.drawer__inner, .drawer_inner, [class*="drawer__inner"]');
      if (inner) {
        inner.style.transform = 'translateX(0)';
        inner.style.visibility = 'visible';
      }

      return;
    }

    const trigger =
      config.cartDrawerTriggerSelector ? document.querySelector(config.cartDrawerTriggerSelector) : null;

    if (trigger) {
      closeWrongMobileMenu();
      trigger.click();
      return;
    }

    window.location.href = apiUrl('/cart');
  };

  const findProductFormFromButton = button => {
    return (
      button.closest(config.productFormSelector) ||
      button.closest('form') ||
      document.querySelector(config.productFormSelector)
    );
  };

  const isBuyButton = button => {
    if (!button) return false;

    const buttonText = normalizeLower(button.textContent || button.value || '');

    return (
      button.matches(config.buyNowSelector) ||
      buttonText.includes('send this gift now') ||
      buttonText.includes('buy now') ||
      buttonText.includes('add to cart') ||
      buttonText.includes('send gift') ||
      buttonText.includes('send this gift')
    );
  };

  const handleBuyNowClick = async event => {
    if (!isAddonEnabledProductPage()) return;

    const button = event.target.closest(
      `${config.buyNowSelector}, button[type="submit"], input[type="submit"], [data-add-to-cart], [data-product-submit]`
    );

    if (!button) return;
    if (!isBuyButton(button)) return;

    const form = findProductFormFromButton(button);

    if (!form || !form.matches(config.productFormSelector)) return;

    if (state.adding) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (!validateProductForm(form)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    await openPopup(form);
  };

  const handleFormSubmit = async event => {
    if (!isAddonEnabledProductPage()) return;

    const form = event.target;

    if (!form || !form.matches(config.productFormSelector)) return;

    const submitter = event.submitter;
    const fromBuyButton = submitter && isBuyButton(submitter);

    if (!fromBuyButton) return;

    if (state.adding) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (!validateProductForm(form)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    await openPopup(form);
  };

  const handleDirectAddonBlock = event => {
    if (!config.strictBlockAddonVariants) return;
    if (!state.addonVariantIds.size) return;
    if (state.adding) return;

    const form = event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;

    if (!form) return;

    const variantId = getSelectedVariantId(form);

    if (state.addonVariantIds.has(Number(variantId))) {
      const isCurrentProductPageVariant = Number(variantId) === Number(state.currentProductVariantId);

      if (isCurrentProductPageVariant) return;

      event.preventDefault();
      event.stopPropagation();

      alert('This add-on product can be ordered only with a main gift product.');
    }
  };

  const submitFinal = async () => {
    if (state.adding) return;

    const senderCheck = validateSender();

    if (!senderCheck.valid) return;

    saveSenderDetails();

    state.adding = true;
    setStatus('');

    if (els.continueBtn) {
      els.continueBtn.disabled = true;
      els.continueBtn.textContent = 'Adding...';
    }

    try {
      await addItemsToCart(senderCheck.values);

      await closePopup({ openCart: false });

      // Always go directly to Shopify's native checkout after the gift is added.
      window.location.href = apiUrl('/checkout');
      return;
    } catch (error) {
      console.error('[OG Addon] Add error:', error);
      setStatus(error.message || 'Unable to add gift to cart.', 'error');
    } finally {
      state.adding = false;

      if (els.continueBtn) {
        els.continueBtn.disabled = false;
        els.continueBtn.textContent = 'Continue with Gift →';
      }
    }
  };

  const skipAddonsAndCheckout = () => {
    if (state.adding) return;

    // IMPORTANT:
    // Skip/Close on Add-ons step must NOT clear selected add-ons.
    // It only moves the customer to Sender Details.
    if (state.currentSlide === 'addons') {
      setStatus('');
      setSlide('sender');
      return;
    }

    // On Sender Details step, Skip/Close means continue with checkout.
    // Sender fields are optional as per config, and any selected add-ons
    // remain in state.selected and will be added with the main gift.
    submitFinal();
  };

  const handleContinue = () => {
    if (state.currentSlide === 'addons') {
      setSlide('sender');
      return;
    }

    submitFinal();
  };

  const bindCartUnlockEvents = () => {
    document.addEventListener('click', event => {
      const closeClicked = event.target.closest(
        '#CartDrawer .drawer__close, cart-drawer .drawer__close, #CartDrawer [aria-label="Close"], cart-drawer [aria-label="Close"], #CartDrawer .drawer__overlay, cart-drawer .drawer__overlay, .cart-drawer__overlay'
      );

      if (closeClicked) {
        window.setTimeout(unlockPage, 250);
        window.setTimeout(unlockPage, 700);
      }
    }, true);

    document.addEventListener('keyup', event => {
      if (event.key === 'Escape') {
        window.setTimeout(unlockPage, 250);
      }
    });

    document.addEventListener('cart-drawer:close', () => {
      window.setTimeout(unlockPage, 200);
    });

    document.addEventListener('drawer:close', () => {
      window.setTimeout(unlockPage, 200);
    });
  };

  const bindEvents = () => {
    document.addEventListener('click', handleBuyNowClick, true);
    document.addEventListener('submit', handleFormSubmit, true);

    document.addEventListener('submit', handleDirectAddonBlock, true);
    document.addEventListener('click', handleDirectAddonBlock, true);

    $$('[data-og-addon-close]', popup).forEach(node => {
      node.addEventListener('click', event => {
        event.preventDefault();
        skipAddonsAndCheckout();
      });
    });

    if (els.continueBtn) {
      els.continueBtn.addEventListener('click', handleContinue);
    }

    if (els.back) {
      els.back.addEventListener('click', () => {
        saveSenderDetails();
        setSlide('addons');
      });
    }

    if (els.skip) {
      if (!config.enableSkipAddons) {
        hide(els.skip);
      } else {
        els.skip.addEventListener('click', event => {
          event.preventDefault();
          skipAddonsAndCheckout();
        });
      }
    }

    [els.senderName, els.senderPhone, els.senderMessage].forEach(input => {
      if (!input) return;

      input.addEventListener('input', () => {
        if (input === els.senderPhone) {
          els.senderPhone.value = els.senderPhone.value.replace(/\D/g, '').slice(0, 10);
        }

        saveSenderDetails();
      });

      input.addEventListener('change', saveSenderDetails);
      input.addEventListener('blur', saveSenderDetails);
    });

    if (els.senderPhone) {
      els.senderPhone.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitFinal();
        }
      });
    }

    if (els.senderMessage) {
      els.senderMessage.addEventListener('keydown', event => {
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
          event.preventDefault();
          submitFinal();
        }
      });
    }

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) {
        event.preventDefault();
        skipAddonsAndCheckout();
      }
    });

    [
      'cart:updated',
      'cart:refresh',
      'ajaxCart:updated',
      'cart-drawer:updated',
      'cart:change',
      'cart:remove'
    ].forEach(eventName => {
      document.addEventListener(eventName, () => {
        window.setTimeout(cleanupCart, 350);
      });
    });

    document.addEventListener('change', event => {
      if (
        event.target &&
        (
          event.target.matches('[name="updates[]"]') ||
          event.target.matches('.quantity__input') ||
          event.target.closest('.cart-item')
        )
      ) {
        window.setTimeout(cleanupCart, 650);
      }
    });

    document.addEventListener('click', event => {
      const removeClicked = event.target.closest(
        'cart-remove-button, .cart-remove-button, [href*="/cart/change"], [data-cart-remove], [data-remove], button[name="minus"], .quantity__button'
      );

      if (removeClicked) {
        window.setTimeout(cleanupCart, 900);
        window.setTimeout(refreshCartSections, 1200);
      }
    });

    window.addEventListener('pageshow', () => {
      window.setTimeout(unlockPage, 150);
      window.setTimeout(cleanupCart, 500);
    });

    bindCartUnlockEvents();
  };

  bindEvents();

  window.setTimeout(() => {
    if (isAddonEnabledProductPage()) {
      loadProducts(false);
    }

    unlockPage();
  }, 900);

  window.OGAddonPopup = {
    open: openPopup,
    close: () => skipAddonsAndCheckout(),
    cleanupCart,
    unlockPage,
    reloadAddons: async () => {
      state.loaded = false;
      state.products = [];
      state.addonVariantIds.clear();
      await loadProducts(true);
    }
  };
})();